<template v-if="product">

    <PantalladeCarga v-if="creandoPDF == true" titulo="Creando Presupuesto PDF..."></PantalladeCarga>

    <div class="col preciosmoviles">

        <div class="card card-lg shadow-lg" style="border:1px solid #bdbdbd;">
            
            <div class="card-header text-center">
            
                <h3 class="card-title h5" style="padding-bottom:10px;" v-if="product.link"><u style="cursor:pointer;" @click="clickProducto(product.cod, product.price, 'info')">{{product.name}}</u></h3>
                <h3 class="card-title h5" style="padding-bottom:10px;" v-else>{{product.name}}</h3>
                <div class="fs-6" v-if="quotation==false" :style="'color:'+colordeprecios+';'">Desde</div>
                <div class="fs-6" v-if="quotation==true" :style="'color:'+colordeprecios+';'">Precio Final Personalizado</div>


                <div class="fs-5" :style="'color:'+colordeprecios+';'" v-if="productoAnterior == true"><del>{{(product.price*1.20).toFixed(2)}}€</del></div>

                <div class="mb-2">
                    <span class="display-2" :style="'color:'+colordeprecios+';'">{{Math.floor(product.price)}}</span>
                    <span class="fs-5" :style="'color:'+colordeprecios+';'">,{{((Math.floor(product.price)-product.price.toFixed(2))*(-100)).toFixed(0)}}</span>
                    <span :style="'color:'+colordeprecios+';'">{{product.currency}} {{product.period}}</span>
                </div>


                <p class="card-text" style="padding-top:20px; min-height:100px; font: size 12pt; color:#000; font-style: italic;" v-html="product.description"></p>

            </div>

            <div class="text-center" v-if="product.tags" style="padding-top:20px; padding-bottom:20px; width: 80%; margin: 0 auto;">
                <span class="badge semaforo" v-for="etiqueta in product.tags">{{etiqueta}}</span>
            </div>


            <div class="card-body d-flex justify-content-center h-100 py-0">

            <ul class="list-checked list-checked-primary">

                <li class="list-checked-item" style="color:red;" v-if="product.promotion && promocion"><b>PROMOCIÓN: <br>{{product.promotion}}</b></li>
                <li class="list-checked-item" v-for="(feature, index2) in product.features" v-html="feature" :key="index2"></li>
            </ul>
            </div>

            <div class="card-footer text-center">
            <div class="d-grid mb-2">
                <button @click="clickProducto(product.cod, product.price, 'contratar')" class="btn btn-warning" v-html="product.button"></button>
            </div>
            <div class="d-grid mb-2" style="padding-top:20px;" v-if="UrlDescargaPresupuesto">
                <button @click="descargarPDF(product.cod, product.price)" class="btn btn-primary">Descargar Presupuesto 📄</button>
            </div>

            <div class="d-grid mb-2" style="padding-top:20px;" v-if="mostrarInfo == true">
                <button @click="clickProducto(product.cod, product.price, 'info')" class="btn btn-primary">Más Información</button>
            </div>

            </div>
        </div>
    </div>
</template>

<script>

import PantalladeCarga from '.././PantalladeCarga.vue'


export default {
  name: 'Producto',
  components : {PantalladeCarga},
  emits: ["clickProducto"],
  props: {
    
    product: Object,
    quotation: Boolean,
    UrlDescargaPresupuesto: String,
    productoAnterior: Boolean,
    idPresupuesto: String,
    mostrarInfo: Boolean

  },

  data: function () {
    return {
    creandoPDF: false,
    colordeprecios: "#F78104",
    promocion: true
    }
  },

  mounted: async function(){


    if (ColorPrecios) {

        this.colordeprecios = ColorPrecios;

    }

    if (ActivatePromo) {

        if (ActivatePromo == "no")
        {
            this.promocion = false;

        } else {

            this.promocion = true;

        }

    } else {

        this.promocion = false;

    }

  },

  methods: {


    clickProducto : async function(producto, price, tipo){

            
        await this.$emit("clickProducto", producto, price, tipo);


    },

    descargarPDF : async function(producto, price){


        if (this.quotation == true)
        {
            
            this.creandoPDF = true;

            await this.clickProducto(producto, price, "download");

            await window.location.assign(this.UrlDescargaPresupuesto);

            this.creandoPDF = false;

        }

    }


  }

}
</script>


<style lang="scss" scoped>

    @media only screen and (max-width: 768px) {
        
        .display-1 {
            font-size:75pt;

        }

        .display-2 {
            font-size:75pt;

        }
        .preciosmoviles {

            margin-top:10px;
        }


    }

    @media only screen and (min-width: 768px) {

        .preciosmoviles {

            margin-left: 15px;
            margin-right: 15px;
            box-shadow: none;
            max-width: 500px;
        }

        .card-group-md-row {
            box-shadow: none;

        }

        .card-group-md-row {

            background: transparent;
            box-shadow: none;

        }


    }

    .badge {

        padding:10px;
        font-size: 10pt;
        margin:5px;
    }

    .semaforo {

        background: #E1E6EE;
        color: #000;

    }

</style>